import Table from "@material-ui/core/Table"
import React, { useEffect, useState } from "react";
import store from "src/store";
import moment from "moment";
// @ts-ignore
import { Link } from 'react-router-dom'
import PassFailChips from "./pass-fail-chips";
import MyTable from "./MyTable";

export default function CiReviewsTable() {

    const [ciRiviewTableData, setCiReviewTableData] = useState([]);

    const columns = [
        {
            name: 'dateData',
            label: 'Date',
            options: {
                customBodyRender: (value, tableMeta, updateValue) => {
                  return <div>{moment(value.created_on).format("MM-DD-YYYY | hh:mm A")} &nbsp;<PassFailChips pass_expections={value.all_passed_expectation} /></div>;
                },
              },
        },
        {
            name: 'total_simulations',
            label: 'Total simulations in review'
        },
        {
            name: 'total_passed',
            label: 'Total passed'
        },
        {
            name: 'total_failed',
            label: 'Total failed'
        },
        {
            name: 'all_passed_expectation',
            label: 'Passed expectation'
        },
        {
            name: 'linkToReview',
            label: 'Go to review',
            options: {
                customBodyRender: (value, tableMeta, updateValue) => {
                  return <Link to={value}>Detailed results</Link>;
                },
              },
        }
    ];

    useEffect(() => {
        createCiReviewsData();
    }, []);

    const createCiReviewsData = () => {
        if (store.ciReviews.length) {
            let ciTableData = store.ciReviews.map((item) => {
                return {
                    dateData: {
                        created_on: item.created_on,
                        all_passed_expectation: item.simulation_test_result.allPassed_expectation
                    },
                    total_simulations: item.simulation_count,
                    total_passed: item.simulation_test_result.simulationsPassed,
                    total_failed: item.simulation_test_result.simulationsFailed,
                    all_passed_expectation: item.simulation_test_result.allPassed_expectation ? 'Yes' : 'No',
                    linkToReview: item.simulation_test_result.linkToReview

                }
            });
            setCiReviewTableData(ciTableData);
        }
    }

    return (
        <>
            <MyTable
            data={ciRiviewTableData}
            columns={columns}
            options={{
                search: false,
                filter: false,
                sort: false,
                textLabels: {
                  body: {
                    noMatch: 'No CI reviews yet',
                  }
                }
              }}/>
        </>
    )


}